import { RiApps2Line } from '@remixicon/react';

import { AzureAppRegistration } from '../../types/azureAppRegistration';
import { AzureResourceLinks } from './AzureResourceLinks';

type AzureAppRegistrationsProps = {
  appRegistrations: AzureAppRegistration[];
};

export const AzureAppRegistrations = ({ appRegistrations }: AzureAppRegistrationsProps) => {
  return (
    <AzureResourceLinks
      label="App registrations"
      emptyText="No app registrations found"
      icon={<RiApps2Line size={16} aria-hidden="true" focusable="false" />}
      resourceType="app registrations"
      resources={appRegistrations}
    />
  );
};
